import {FC} from 'react';
import {NavLink} from 'react-router-dom';
//mui
import {Box} from '@mui/material';
//icons
import {ReactComponent as DashboardIcon} from '@icons/sidebar/dashboard.svg';
import {ReactComponent as NoteText} from '@icons/sidebar/note-text.svg';
import {ReactComponent as PeopleIcon} from '@icons/sidebar/people.svg';
//constants
import {SIDEBAR} from '@/utils/constants';

import {ROUTER_URL} from '@/utils/enums';
import {organizationSidebarStyle} from '@/layouts/OrganizationTemplate/OrganizationSidebar/OrganizationSidebar.styles';

const AdminSidebar: FC = () => {
	return (
		<Box sx={organizationSidebarStyle.wrap}>
			<Box sx={organizationSidebarStyle.spacer} />
			<Box sx={organizationSidebarStyle.sidebar}>
				<Box sx={{...organizationSidebarStyle.menu, ...organizationSidebarStyle.adminMenu}}>
					<NavLink to={ROUTER_URL.ADMIN_DASHBOARD} style={organizationSidebarStyle.menuItem}>
						<DashboardIcon /> {SIDEBAR.ADMIN_DASHBOARD}
					</NavLink>
					<NavLink to={ROUTER_URL.ADMIN_ORGANIZATION} style={organizationSidebarStyle.menuItem}>
						<PeopleIcon /> {SIDEBAR.ADMIN_ORGANIZATION}
					</NavLink>
					<NavLink to={ROUTER_URL.ADMIN_EVENTS} style={organizationSidebarStyle.menuItem}>
						<NoteText /> {SIDEBAR.ADMIN_EVENTS}
					</NavLink>
				</Box>
			</Box>
		</Box>
	);
};

export default AdminSidebar;
